__turbopack_context__.v({
  "socialAnchor": "NewSocialIcon-module-scss-module__VMVULG__socialAnchor",
});
